import { Wrap, WrapItem, Button, Card, Text, Tooltip } from "@chakra-ui/react";
import { textStyle, variant } from "theme/names";

type Card = {
    title: string;
    key: string;
    label: string;
};

type CardListProps = {
  cards: Card[];
  onClick: (topic: string) => void;
  isLoading: boolean;
};

export const CardList = ({ cards, onClick, isLoading }: CardListProps) => {
  return (
    <Wrap pt="4px">
      {cards.map((card, index) => (
        <WrapItem key={index}>
          <Card
            borderRadius={"7px"}
            size="md"
            padding="1px"
            background="linear-gradient(310deg, rgba(49,107,255,1) 0%, rgba(236,97,129,1) 100%)"
          >
            <Tooltip label={card.label}>
              <Button
                size="sm"
                isLoading={isLoading}
                fontSize="sm"
                background="linear-gradient(290deg, rgba(239,240,252,1) 0%, rgba(248,239,246,1) 100%)"
                border="0px transparent"
                onClick={() => onClick(card.key)}
              >
                <Text textStyle={textStyle["body.medium.light"]}>
                  {card.title}
                </Text>
              </Button>
            </Tooltip>
          </Card>
        </WrapItem>
      ))}
    </Wrap>
  );
};
